/**
 * DRAPE logo scroll detection — D-02 + UI-SPEC §Logo Behavior Contract
 *
 * Uses IntersectionObserver on a sentinel div positioned at 80px from top,
 * NOT a scroll listener (per PITFALLS.md #5 — perf rule).
 *
 * Toggles body[data-drape-scrolled="true|false"] which CSS in drape-logo.liquid
 * uses to swap visible logo (green wordmark <-> gold wordmark with opacity transition).
 *
 * Phase 3 addition: ALSO toggles class header--sticky on .drape-header element
 * (in addition to body attribute — Phase 2 storytelling pages depend on body attr).
 *
 * Reduced-motion handling lives in CSS (transition: none under prefers-reduced-motion).
 */
(function () {
  'use strict';

  /**
   * Apply scrolled state to both body attribute AND .drape-header class.
   * @param {boolean} isScrolled — true when page is scrolled past threshold
   */
  function applyScrolledState(isScrolled) {
    // Phase 1+2: body attribute (DO NOT remove — Phase 2 pages depend on it)
    document.body.dataset.drapeScrolled = isScrolled ? 'true' : 'false';

    // Phase 3: toggle header--sticky class on .drape-header (D-12)
    var headerEl = document.querySelector('.drape-header');
    if (headerEl) {
      if (isScrolled) {
        headerEl.classList.add('header--sticky');
      } else {
        headerEl.classList.remove('header--sticky');
      }
    }
  }

  function init() {
    var sentinel = document.querySelector('[data-drape-logo-sentinel]');
    if (!sentinel) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: rAF-throttled scroll listener (rare — IE / very old browsers)
      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            applyScrolledState(window.scrollY >= 80);
            ticking = false;
          });
        },
        { passive: true }
      );
      // Set initial state (handles mid-page load)
      applyScrolledState(window.scrollY >= 80);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Sentinel sits at top:80px absolute. When page scrolls past 80px,
          // sentinel exits viewport top edge → entry.isIntersecting = false → set scrolled state.
          applyScrolledState(!entry.isIntersecting);
        });
      },
      {
        threshold: 0
      }
    );

    observer.observe(sentinel);

    // Set initial state immediately for users who land mid-page (D-12 consistency)
    requestAnimationFrame(function () {
      applyScrolledState(window.scrollY >= 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
